export default __webpack_public_path__ + "static/media/back.f570c61a.svg";